<template>
  <sIcon
    v-if="loading"
    class="align-self-center my-3"
    color="var(--white-color)"
    size="30"
    spin
    type="loading"/>
  <v-data-table
    v-else
    ref="table"
    v-model="selected_positions"
    calculate-widths
    class="elevation-0 plan-table main__light_green"
    disable-pagination
    :headers="headers"
    hide-default-footer
    item-key="index"
    :items="[{}]"
    :no-data-text="$t('Tenders.NoData')"
    :sort-by.sync="sort_by"
    :sort-desc.sync="sort_desc"
    @input="groupSelect">
    <template #[`header.data-table-select`]>
      <v-simple-checkbox
        v-model="selected_groups"
        color="var(--black-color)"
        :indeterminate="indeterminate_all"/>
    </template>
    <template #item>
      <tr
        class="plan-tr"
        style="width: 100%">
        <td
          class="pa-0"
          :colspan="headers.length "
          style="padding:0!important">
          <v-treeview
            ref="treeview"
            v-model="selected_positions"
            item-key="index"
            :items="groups"
            :open="openItems"
            open-on-click
            return-object
            selectable
            selected-color="var(--black-color)"
            transition
            @update:open="openTreeRow">
            <template #label="{ item, open }">
              <v-simple-table v-if="item.children && item.children.length">
                <template #default>
                  <tbody>
                    <tr class="plan-tr plan-row">
                      <td
                        v-if="headers[1].visible"
                        class="text-start"
                        :style="'max-width:' + headers[1].width + 'px;'"
                        :width="headers[1].width">
                        <div class="flex flex-wrap">
                          <sIcon
                            v-if="!!item.children"
                            class="my-auto mx-2"
                            :rotate="open ? 0 : -90"
                            size="10"
                            type="arrow"/>
                          <span v-dompurify-html="item.name || (item.resource ? item.resource.fullName : item.resourceName) "/> <!-- !! пошук на фронті, виділяється html-ом   -->
                        </div>
                      </td>
                      <td
                        v-if="headers[2].visible"
                        class="text-start"
                        :style="'max-width:' + headers[2].width + 'px;'"
                        :width="headers[2].width">
                        <ReceiverTooltip :receivers-data="Object.values(getCommonDepartaments(item))"/>
                      </td>
                      <td
                        v-if="headers[3].visible"
                        class="text-start"
                        :style="'max-width:' + headers[3].width + 'px;'"
                        :width="headers[3].width">
                        <CreatorsTooltip
                          :key="item.code + item.children"
                          :common-creators="getCommonCreators(item)"/>
                      </td>
                      <td
                        v-if="headers[4].visible"
                        class="text-start"
                        :style="'max-width:' + headers[4].width + 'px;'"
                        :width="headers[4].width">
                        <DateSpan :items="item.children"/>
                      </td>
                      <td
                        v-if="headers[5].visible"
                        class="text-start"
                        :style="'max-width:' + headers[5].width + 'px;'"
                        :width="headers[5].width">
                        {{ (item.quantity ? item.quantity.quantity : 0) | formSum }}
                        {{ (item.quantity ? item.quantity.unit : '' ) }}
                      </td>
                      <td
                        v-if="headers[6].visible"
                        class="text-start"
                        :style="'max-width:' + headers[6].width + 'px;'"
                        :width="headers[6].width">
                        <span v-if="+item.summa">{{ item.summa | formSum }} {{ getCurrencyName(item, item.summa) }}</span>
                        <span v-else>–</span>
                      </td>
                      <td class="text-start item-count secondary__green_not_active--text">
                        {{ item.children.length }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-simple-table
                v-else
                class="main__light_green">
                <template #default>
                  <tbody>
                    <tr
                      :id="item.headerId"
                      class="plan-tr plan-row">
                      <td
                        v-if="headers[1].visible"
                        :key="item.name + item.searched_description + item.id"
                        class="text-start"
                        :style="'max-width:' + headers[1].width + 'px;'"
                        :width="headers[1].width">
                        <router-link :to=" {name: 'planitem', params: { id: item.headerId, org: $route.params.org}} ">
                          <span
                            v-dompurify-html="item.name || (item.resource ? item.resource.name : item.resourceName)"
                            class="row-name"/> <!-- !! пошук на фронті, виділяється html-ом   -->
                        </router-link>
                        <v-subheader v-dompurify-html="item.searched_description || item.description || '–'"/> <!-- !! пошук на фронті, виділяється html-ом   -->
                      </td>
                      <td
                        v-if="headers[2].visible"
                        class="text-start"
                        :style="'max-width:' + headers[2].width + 'px;'"
                        :width="headers[2].width">
                        <ReceiverTooltip
                          v-if="item.receiver && ( item.receiver.name
                            || item.receiver.organizationAddress && (item.receiver.organizationAddress.address
                              || item.receiver.organizationAddress.organizationAddressName))"
                          :receivers-data="[item.receiver]"/>
                        <span
                          v-else
                          class="text-start">{{ $t('Common.NoData') }}</span>
                      </td>
                      <td
                        v-if="headers[3].visible"
                        class="text-start"
                        :style="'max-width:' + headers[3].width + 'px;'"
                        :width="headers[3].width">
                        <PersonTooltip
                          v-if="item.applicant"
                          :avatar="item.applicant.avatar"
                          :department="item.applicant.department"
                          :item="item.applicant"
                          :name="item.applicant.fullName"
                          with_photo/>
                        <PersonTooltip
                          v-else
                          :item="item"
                          :name="item.applicant"
                          with_photo/>
                      </td>
                      <td
                        v-if="headers[4].visible"
                        class="text-start"
                        :style="'max-width:' + headers[4].width + 'px;'"
                        :width="headers[4].width">
                        <DateSpan
                          date="approvedSupplyDate"
                          :item="item"/>
                      </td>
                      <td
                        v-if="headers[5].visible"
                        class="text-start"
                        :style="'max-width:' + headers[5].width + 'px;'"
                        :width="headers[5].width">
                        <span
                          v-if="item.approvedQuantity || item.approvedQuantity == 0"
                          class="mr-1"> {{ item.approvedQuantity | formSum }} </span>
                        <span
                          v-if="item.resource && item.resource.unit"
                          class="ml-1">{{ item.resource.unit.name }}</span>
                        <span v-else-if="item.unit"> {{ item.unit.name }}</span>
                      </td>
                      <td
                        v-if="headers[6].visible"
                        class="text-start"
                        :style="'max-width:' + headers[6].width + 'px;'"
                        :width="headers[6].width">
                        <span v-if="+item.summa">
                          {{ item.summa | formSum }} {{ getCurrencyName(item, item.summa) }}
                        </span>
                        <span v-else>–</span>
                      </td>
                      <td class="text-start item-count secondary__green_not_active--text mr-3"/>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
          </v-treeview>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import DateSpan from 'components/common/elements/DateSpan.vue'
import PersonTooltip from 'components/common/blocks/PersonTooltip.vue'
import ReceiverTooltip from 'components/common/blocks/ReceiverTooltip.vue'
import CreatorsTooltip from 'components/common/elements/CreatorsTooltip.vue'

import { functionMixin, storageMixin, filterSortMixin, tenderMixin, modalMixin } from 'mixins'
import moment from 'moment'

export default {
  name: 'planItemsTable',
  mixins: [ functionMixin, storageMixin, filterSortMixin, tenderMixin, modalMixin ],
  data() {
    return {
      groups: [],
      selected_positions: [],
      sort_by: ['name'],
      sort_desc: [true],
      grouped_by: 'resource',
      rows: [],
      categories: [],
      loading: false,
      resourceGroups: [],
      openItems: [],
      needReadLocalStorage: true
    }
  },
  props: {
    filters: Object,
    choosedHeaders: Array,
    allHeaders: Array,
    items: Array,
    group: Object,
    creators: Array,
    all_categories: Array
  },
  created() {
    this.getGroupsBy(this.grouped_by)
    this.selected_positions = this.group?.selectedItems?.map(item => ({...item, index: item.rowId + '/' + item.headerId, }))
  },
  computed: {
    headers() {
      let headers = []
      this.allHeaders.forEach(el => {
        headers.push(Object.assign({}, el))
      })
      headers = headers.map( el => {
        let item = this.choosedHeaders.find(elem => el.id == elem.id)
        if (item) {
          el.visible = true
          return el
        } else {
          el.text = ''
          el.value = ''
          el.visible = false
          el.sortable = false
          return el
        }
      })
      return headers
    },
    indeterminate_all() {
      return !!this.selected_positions.length &&  this.selected_positions.length != this.rows.length
    },
    selected_groups: {
      get() {
        return this.selected_positions.length == this.rows.length
      },
      set(value) {
        this.selected_positions = value ? this.rows : []
      }
    },
  },
  methods: {
    /**
     * Сохраняем развернутые ноды
     */
    openTreeRow(item) {
      if (!this.needReadLocalStorage) { return }
      this.openItems = item
      this.$_savePropToLocalStorage(`planning.openRow.${this.group.id}`, item.map(i => i.index))
    },
    /**
     * Восстанавливаем открытые пункты
     */
    applyPrevOpenRow() {
      if (!this.groups) { return }
      const prevValues = this.$_getPropFromLocalStorage(`planning.openRow.${this.group.id}`, [])
      if (!prevValues?.length) { return }

      this.groups.forEach((group) => {
        prevValues.forEach((prevValue) => {
          const item = this.$_searchTree(group, prevValue, 'index', 'children')
          if (item) {
            this.openItems.push(item)
          }
        })
      })
      this.needReadLocalStorage = false
    },
    goToDesc(item) {
      if (!item.headerId) {
        return
      }
      this.$router.push({name: 'planitem', params: { id: item.headerId,  org: this.$route.params.org}})
    },
    getCommonDepartaments(item) {
      let departaments =  {},
        getName = (item) => item.receiver.name || item.receiver.address
      if ( item.receiver ) {
        return item.receiver
      }
      if (!item.children) {
        return {}
      }
      item.children.forEach(child => {
        if (child.children) {
          child.children.forEach(item => {
            if (item.receiver && getName(item)
              && !departaments[getName(item)]) {
              departaments[getName(item)] = item.receiver
            } else if ( item.receiver &&
               Object.entries(item.receiver).find(el =>
                 el[0] == el[1].name || el.address
                  || el.name)) {
              departaments = item.receiver
            }
          })
        } else {
          if (child.receiver && getName(child) && !departaments[getName(child)]) {
            departaments[getName(child)] = child.receiver
          }
        }
      })
      return departaments
    },
    getCommonCreators(item) {
      let creators = [],
        checkAll = (applicant) => {
          if ( !this.$_.some(creators, ['id', applicant.id] ) ) {
            creators.push(applicant)
          }
        }

      if (!item.children || !item.children.length || item.applicant) {
        return item.applicant
      }
      item.children.forEach(child => {
        if (!child.applicant) { return }
        if ( Array.isArray( child.applicant ) ) {
          child.applicant.forEach(appl => checkAll(appl))
        } else {
          checkAll(child.applicant)
        }
      })

      return creators
    },
    getMinDate(item) {
      let minSupplyDate = {}
      if (!item.children) { return {} }

      item.children.forEach(child => {
        if (child.children) {
          child.children.forEach(item => {
            if (item.approvedPriority?.id ) {
              return minSupplyDate = item
            }
            if (item.approvedSupplyDate) {
              minSupplyDate = minSupplyDate && minSupplyDate.approvedSupplyDate ?
                this.compareDates(item.approvedSupplyDate, minSupplyDate.approvedSupplyDate) ? item : minSupplyDate : item
            }
          })
        } else {
          if (child.approvedPriority?.id ) {
            return minSupplyDate = child
          }
          if (child.approvedSupplyDate) {
            minSupplyDate = minSupplyDate && minSupplyDate.approvedSupplyDate ?
              this.compareDates(child.approvedSupplyDate, minSupplyDate.approvedSupplyDate) ? child : minSupplyDate : child
          }
        }
      })
      return minSupplyDate
    },
    compareDates(date1, date2) {
      if (!date1 || !date2) {
        return
      }
      let dateTime1 = moment(date1).format('x'),
        dateTime2 = moment(date2).format('x')
      return dateTime1 < dateTime2
    },
    getSumByQuantity(items) {
      let result, unit = ''
      result = items?.reduce((total, el) => {
        if (!unit && el.unit?.name) {
          unit = el.unit.name
        }
        if ( el.quantity?.unit ) {
          unit = !unit || unit == el.quantity?.unit ? el.quantity?.unit : '-'
        }
        if (el.children  ) {
          return total + parseFloat(this.getSumByQuantity(el.children).quantity )
        } else {
          return total + el.approvedQuantity
        }
      }, 0 )

      return { quantity: result , unit }
    },
    getSubByRows (rows) {
      let result = 0, get_sum = item => item.summa || ((item.approvedQuantity || item.declaredQuantity) * item.price)
      if ( rows.children ) {
        rows = rows.children
      }
      if ( Array.isArray(rows)) {
        rows.forEach(row => {
          let summa = get_sum(row)
          result += parseFloat(summa) || 0
        })
      } else {
        result = get_sum(rows)
      }
      return  result
    },
    findWidth(width, num) {
      let tableW =  this.$refs.table.$vnode.elm.clientWidth
      width = Number.parseFloat(width)
      let res = num == 7 ? width + 68 + 'px' :
        num == 0 ? '50px' :
          num == 1 ? tableW * width / 100 - 65 + 'px' :
            width  + '%'
      return `width: ${res}`
    },
    groupSelect(el) {
      // eslint-disable-next-line vue/no-mutating-props
      this.group.selectedItems = el
      this.$emit('updateSelectedCount',  this.group)
    },
    sort(ar) {
      return ar.sort((a, b) => {
        let res = 0, first = a[this.sort_by[0]], second = b[this.sort_by[0]]
        if ( this.sort_by[0] == 'name') {
          first = a.resource?.category?.name || first
          second = b.resource?.category?.name || second
        } else if ( this.sort_by[0] == 'quantity' ) {
          first = first?.quantity || first
          second = second?.quantity || second
        }
        if ( !first && second ) {
          res = -1
        } else if ( first && !second ) {
          res = 1
        } else if ( !first && !second ) {
          res = 0
        } else if ( this.sort_by[0] == 'approvedSupplyDate' ) {
          res = moment(first) > moment(second) ? 1 : -1
        } else if ( typeof first == 'number' || parseFloat(first)) {
          res = parseFloat(( first  + '').replace(/[\s]/g, ''))
            > parseFloat(( second  + '').replace(/[\s]/g, '')) ? 1 : -1
        } else if ( typeof first == 'object' ) {
          let setObj = (obj) => {
            if (Object.keys(obj).length > 1 && (this.sort_by[0] == 'receiver' || this.sort_by[0] == 'applicant' )) {
              return 'a'
            } else if (Object.keys(obj).length == 1 && (this.sort_by[0] == 'receiver' )) {
              return Object.keys(obj)[0]
            } else if (Object.keys(obj).length == 1 && (this.sort_by[0] == 'applicant' )) {
              let r = Object.values(obj)
              return r?.fullName || ''
            }
          }
          first = setObj(first)
          second = setObj(second)

          res = first?.localeCompare(second)
        }  else {
          res = first?.localeCompare(second)
        }
        if (this.sort_desc[0]) {
          return res
        } else {
          return -res
        }
      })
    },
    getGroupsBy(  ) {
      this.loading = true
      let new_categories = [],
        modifyItem = (item, index) => {
          return {
            ...item,
            summa: this.getSubByRows(item) ,
            index: index || item.index || (item.rowId + '/' + item.headerId ),
            sort_by: this.sort_by,
            sort_desc: this.sort_desc
          }
        },
        modifyGroup = (item) => {
          // формування полей для групи  з сумою дочірніх полей
          let summa = '', currency
          currency = item.currency || item.children?.reduce((total, el) => {
            return total = !total || total.symbol == el.currency?.symbol ? el.currency : '-'
          }, '' )

          if ( item.children.every(el => el.hasOwnProperty('summa'))  ) {
            summa = this.getSubByRows(item.children)
          }
          let ret = {
            ...item,
            name: item.title || item.name,
            index: item.code || this.group.code || item.id ,
            summa,
            currency,
            quantity: this.getSumByQuantity(item.children),
            approvedSupplyDate: this.getDate(item.children),
            receiver: this.getCommonDepartaments(item),
            applicant: this.getCommonCreators(item),
            sort_by: this.sort_by,
            sort_desc: this.sort_desc
          }
          return ret
        },
        getCildr = (arr) => this.sort( this.$_.map( this.$_.filter( arr  , el => el?.children)  ,  modifyGroup )),
        createTree = (item) => {
          let group = this.getResourcesGroup( item?.group_id || item.parentCode)
          if (!group?.code) {
            let without_cat = new_categories.find(el => el.code == 'without_cat')
            if ( !without_cat ) {
              new_categories.push( modifyGroup({
                name: this.$t('Tenders.WithoutCategory'),
                children: [item] ,
                code: 'without_cat'
              })
              )
            } else {
              without_cat.children.push(item)
            }
          }

          let addToGroup = (group, item) => {
            if ( !group?.children ) { return }

            let already_added = group?.children?.findIndex(el => el.index == item?.index)
            if ( already_added == -1 ) {
              group?.children?.push( Object.assign({}, item ) )
            }  else {
              let current = group.children[already_added]
              current.children?.forEach(it => addToGroup(item, it) )
              group.children[already_added] = Object.assign(current, item)
            }
          }

          addToGroup(group, item)
          group = getCildr([group])[0] || {}
          if (!group?.parentCode ) {
            let already_gr = new_categories.find(el => el.code == group?.code)
            if (!already_gr) {
              new_categories.push( group )
            }
            return group
          } else if ( group?.parentCode) {
            return createTree(group)
          }
        }
      this.rows = this.items.map(el => modifyItem(el))
      let groups = this.$_.groupBy(this.rows, el => el?.resource?.name)
      groups = Object.values(groups).map(gr => modifyGroup({
        name: gr[0]?.resource?.name || gr[0].resourceName,
        children: this.sort( gr ),
        id: gr[0]?.resource?.id + '–' + gr[0]?.resource?.name,
        group_id: gr[0]?.resource?.category?.code
      }))

      let proms = groups.map(async el => await createTree(el))
      Promise.all(proms).then(() => {
        new_categories = getCildr(new_categories)
        this.groups = new_categories
        if (this.needReadLocalStorage) {
          this.applyPrevOpenRow()
        } else {
          this.openAll()
        }
      })
        .finally(() => this.loading = false)
    },
    sortGroups() {
      let func = (array ) => {
        this.sort(array)
        array.forEach(item => {
          if ( item?.children) {
            func(item.children)
          }
        })
      }
      func(this.groups)
    },
    getResourcesGroup( code ) {
      let result = this.all_categories?.find(cat => cat?.code == code),
        old = this.categories?.find(cat => cat?.code == code )
      if ( !old && result?.code) {
        result = Object.assign({}, {...result, children: result.children?.slice(0) })
        result.children = []
        this.categories.push(result)
        return result
      } else if (old) {
        return Object.assign({}, old )
      } else {
        return {}
      }

    },
    openAll() {
      if ( this.filters?.filters?.length || this.filters?.search ) {
        if (this.$refs.treeview) {
          this.$refs.treeview?.updateAll(true)
        } else {
          setTimeout(() => {
            this.$refs.treeview?.updateAll(true)
          }, 300)
        }

      }
    }
  },
  watch: {
    sort_by(val) {
      if (val.length > 0) {
        this.sortGroups()
      }
    },
    sort_desc(val) {
      if (val.length > 0) {
        this.sortGroups()
      }
    },
    items(val) {
      let func = (  array ) => {
        array.forEach(el => {
          if (el.children) {
            func( el.children)
          } else  {
            let item = val.find(it => it.id == el.id)
            if (item) {
              Object.assign(el, item )
            }
          }
        })
      }
      func( this.groups)
      this.openAll()
      // val
      // this.selected_positions = this.group.selectedItems.map(item => ({...item, index: item.id + '–' + this.group.id, }))
    }
  },
  components: {
    DateSpan,
    PersonTooltip,
    ReceiverTooltip,
    CreatorsTooltip
  }
}
</script>
<style lang="scss" scoped>
  .plan-row {
    height: 50px;
    .item-count {
      padding: 0;
      width: 50px;
    }
  }
</style>
<style lang="scss">
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: none
}
.plan-table {
  &.v-data-table table {
    width: 100%;
    th:not(:first-child) {
      padding: 0 !important;
    }
      td , .plan-tr td {
      border-bottom: none !important;
    }
  }
  .v-treeview-node__children {
    border-bottom: 0px solid var(--v-main__green-base);
  }
  .v-treeview-node .v-treeview-node__checkbox, .v-simple-checkbox .v-icon{
    color: rgba(var(--black-color-rgba), 0.2);
    font-size: 21px;
  }
  .v-treeview-node__toggle, .v-treeview-node__root:last-child .v-treeview-node__root:first-child{
    display: none
  }
  .plan-tr .text-start:first-child {
    padding-left: 0 !important;
  }
  td , .plan-tr td {
    padding: 0 !important;
    white-space: normal;
    border: none !important;
    border-bottom: none !important;
  }
  .v-treeview-node .v-treeview-node__root {
    border-bottom: 1px solid var(--v-main__green-base) ;
  }
  .v-treeview > .v-treeview-node.v-treeview-node--click , .v-treeview-node.v-treeview-node--click  {
    & > .v-treeview-node__root {
      &, tr,/*Фикс фона у аватара */
      &, td {
        background-color: var(--v-secondary__green_chosen-base) !important;
      }
    }
  }
  .v-treeview-node.v-treeview-node--leaf .v-treeview-node__root {
    &, tr,/*Фикс фона у аватара */
    &, td {
      background-color: var(--v-main__light_green-base) !important;
    }

    border-bottom: 1px solid var(--v-main__green-base) ;
  }
  .v-treeview-node__root {
    padding: 0 ;
  }
  .v-treeview-node__root:hover::before{
    opacity: 0 !important;
  }
  .v-treeview-node__checkbox {
    align-self: flex-start;
    margin-top: 16px !important;
  }
  .v-treeview .v-treeview-node .v-treeview-node__root .v-treeview-node__checkbox:nth-child(2) {
    margin: 0 0 0 14px;
  }
  .v-treeview-node--leaf .v-treeview-node__level {
    // display: none;
    width: 18px;
  }

  .v-data-table__wrapper {
    td, th {
      padding: 10px !important;
    }
    // max-height: calc(100vh - 250px);
  }
}
</style>
